new Vue({
    delimiters: ['[[', ']]'], // change because vue and django using the same args 
    el: '#footer',
    data: {
      
    },
})

$(document).ready(function () {

    if (window.matchMedia("(max-width: 991px)").matches) {
        const footerSection = document.querySelectorAll('.footer-section');
        if(footerSection.length) {
            footerSection.forEach((item) => {
                let footerTitle = item.querySelector('.footer-title');
                let footerContent = item.querySelector('.footer-section--content');
                if(footerTitle && footerContent) {
                    footerTitle.addEventListener('click', () => {
                        footerTitle.classList.toggle('active');
                        footerContent.classList.toggle('active');
                    });
                }
            });
        }
    }
});